import React, {
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
  useContext
} from "react";

import {
  Link,
  useParams
} from "react-router-dom";

import {
  useInView
} from "react-intersection-observer";

import Skeleton from "../skelton.jsx";

import {
  Helmet
} from "react-helmet-async";

import {
  DeviceContext
} from "../index.jsx";

import he from "he";


const categoryMap = {

  "latestnews-25.html": {
    firstStep: "LatestNews",
    catId: 25,
    pageTitle:
      "Andhra Pradesh Top Story | Telugu Top Story News | Top Story | Top Story News"
  },

  "teluguoneexclusive-55.html": {
    firstStep: "TeluguOne Exclusive",
    catId: 55,
    pageTitle:
      "TeluguOne Exclusive News | Andhra Pradesh Political News | AP Political News | Political Gossips"
  },

  "history-57.html": {
    firstStep: "History",
    catId: 57,
    pageTitle:
      "Telugu History | Historical Stories | Andhra Pradesh History | TeluguOne"
  },

  "politics-39.html": {
    firstStep: "Politics",
    catId: 39,
    pageTitle:
      "Andhra Pradesh Political News | AP Politics | Political News & Updates | TeluguOne"
  },

  "political-39.html": {
    firstStep: "Politics",
    catId: 39,
    pageTitle:
      "Andhra Pradesh Political News | AP Politics | Political News & Updates | TeluguOne"
  },

  "analytical-45.html": {
    firstStep: "Analytical",
    catId: 45,
    pageTitle:
      "Andhra Pradesh Analytical News | Political Analysis | TeluguOne"
  },

  "lifestyle-35.html": {
    firstStep: "lifestyle",
    catId: 35,
    pageTitle:
      "Lifestyle News | Health, Fashion, Food & Lifestyle Tips | TeluguOne"
  },

  "health-34.html": {
    firstStep: "healthnews",
    catId: 34,
    pageTitle:
      "Health News | Health Tips, Fitness, Diet & Wellness | TeluguOne"
  },

  "specialAnalysis-60.html": {
    firstStep: "specialAnalysis",
    catId: 60,
    pageTitle:
      "Special Stories | Special Reports, Analysis & Insights | TeluguOne"
  },

  "andhrapradesh-43.html": {
    firstStep: "ఆంధ్రప్రదేశ్",
    catId: 43,
    pageTitle:
      "Andhra Pradesh News | AP Latest News, Politics & Updates | TeluguOne"
  },

  "telangana-24.html": {
    firstStep: "తెలంగాణ",
    catId: 24,
    pageTitle:
      "Telangana News | Latest Telangana News, Politics & Updates | TeluguOne"
  },

  "india-23.html": {
    firstStep: "భారత్",
    catId: 23,
    pageTitle:
      "India News | Latest National News, Politics & Updates | TeluguOne"
  },

  "world-58.html": {
    firstStep: "ప్రపంచం",
    catId: 58,
    pageTitle:
      "World News | Latest International News & Global Updates | TeluguOne"
  },

  "business-54.html": {
    firstStep: "బిజినెస్",
    catId: 54,
    pageTitle:
      "Business News | Latest Business, Economy & Market Updates | TeluguOne"
  },

  "technology-33.html": {
    firstStep: "టెక్నాలజీ",
    catId: 33,
    pageTitle:
      "Technology News | Latest Tech News, Gadgets & Digital Updates | TeluguOne"
  },

  "sports-53.html": {
    firstStep: "క్రీడలు",
    catId: 53,
    pageTitle:
      "Sports News | Latest Sports News, Scores & Updates | TeluguOne"
  }

};


// ======================================================
// RESOLVE CATEGORY
// ======================================================

const resolveCategory = (type) => {

  const mapped = categoryMap[type];

  if (mapped) {
    return mapped;
  }

  const match = type?.match(/-(\d+)\.html$/);

  if (!match) {
    return null;
  }

  const catId = Number(match[1]);

  const wordPart = type
    .slice(0, match.index)
    .replace(/[-_]+/g, " ")
    .trim();

  const titleCased = wordPart
    ? wordPart
        .split(" ")
        .filter(Boolean)
        .map(
          (w) =>
            w.charAt(0).toUpperCase() +
            w.slice(1)
        )
        .join(" ")
    : "Latest";

  return {
    firstStep: "",
    catId,
    pageTitle: `${titleCased} News | TeluguOne`
  };

};


const NewsLeftSideSection = ({
  categoryPageData,
  error,
  catId,
  pageTitle: pageTitleProp,
  parentLoading
}) => {

  const { type } = useParams();

  const useIsomorphicLayoutEffect =
    typeof window !== "undefined"
      ? useLayoutEffect
      : useEffect;

  const { mobile } = useContext(DeviceContext);

  const MAX_ITEMS = 100;

  // FIX: the catId the URL is actually asking for
  const requestedCatId = resolveCategory(type)?.catId ?? catId;

  // FIX: the catId the SSR/parent data actually belongs to.
  // The parent should pass categoryPageData = { catId, categoryNewsdata }.
  // Falls back to the `catId` prop when it isn't stamped on the data.
  const ssrCatId = categoryPageData?.catId ?? catId ?? null;

  // FIX: only trust SSR data when it matches the URL category.
  // Stale data from the previous category is ignored.
  const ssrMatches =
    Boolean(categoryPageData) &&
    ssrCatId != null &&
    requestedCatId != null &&
    Number(ssrCatId) === Number(requestedCatId);

  const [categoryNewsData, setCategoryNewsData] =
    useState(
      (ssrMatches
        ? categoryPageData?.categoryNewsdata || []
        : []
      ).slice(0, MAX_ITEMS)
    );

  const [loading, setLoading] =
    useState(
      parentLoading ??
      (!ssrMatches && !error)
    );

  const [moreError, setMoreError] =
    useState(error || null);

  const [hasMore, setHasMore] =
    useState(
      (
        (ssrMatches
          ? categoryPageData?.categoryNewsdata?.length
          : 0) || 0
      ) < MAX_ITEMS
    );

  const [noData, setNoData] =
    useState(
      ssrMatches &&
      !error &&
      (
        categoryPageData
          ?.categoryNewsdata
          ?.length ?? 0
      ) === 0
    );


  const startRef = useRef(
    Math.min(
      (ssrMatches
        ? categoryPageData
            ?.categoryNewsdata
            ?.length
        : 0) || 0,
      MAX_ITEMS
    )
  );

  const isFetchingRef =
    useRef(false);

  const lastCatIdRef =
    useRef(catId);

  // ====================================================
  // INFINITE SCROLL
  // ====================================================

  const {
    ref: loaderRef,
    inView
  } = useInView({
    threshold: 0,
    rootMargin: "0px 0px 50px 0px"
  });


  // ====================================================
  // SYNC WITH SSR / PARENT DATA
  // ====================================================

  useEffect(() => {

    // FIX: never write stale parent data (from a previous
    // category) into state — the fetch effect below will
    // load the correct category instead.
    if (!ssrMatches) {
      return;
    }

    const ssrNews =
      (
        categoryPageData
          ?.categoryNewsdata || []
      ).slice(0, MAX_ITEMS);

    setCategoryNewsData(ssrNews);

    setMoreError(error || null);

    setLoading(
      parentLoading ??
      false
    );

    setNoData(
      ssrNews.length === 0
    );

    startRef.current =
      ssrNews.length;

    lastCatIdRef.current =
      requestedCatId;

    setHasMore(
      ssrNews.length < MAX_ITEMS
    );

    isFetchingRef.current =
      false;

  }, [
    categoryPageData,
    error,
    catId,
    parentLoading,
    ssrMatches,
    requestedCatId
  ]);


  // ====================================================
  // RESET ON CATEGORY CHANGE
  // ====================================================

  useIsomorphicLayoutEffect(() => {

    const currentCategory =
      resolveCategory(type);

    if (!currentCategory) {
      return;
    }

    setCategoryNewsData([]);

    setMoreError(null);

    setNoData(false);

    setHasMore(true);

    setLoading(true);

    startRef.current = 0;

    lastCatIdRef.current =
      currentCategory.catId;

    isFetchingRef.current =
      false;

  }, [type]);


  // ====================================================
  // FETCH FIRST PAGE
  // ====================================================

  useEffect(() => {

    const currentCategory =
      resolveCategory(type);

    if (!currentCategory) {
      return;
    }

   
    if (ssrMatches) {
      return;
    }

    let isActive = true;

    const fetchFirstPage = async () => {

      try {

        setLoading(true);

        const total =
          window.innerWidth < 1100
            ? 15
            : 26;

        const response =
          await fetch(
            `https://www.teluguone.com/news_api/catNewsPaginate?catId=${currentCategory.catId}&start=0&total=${total}`
          );

        if (!response.ok) {
          throw new Error(
            "Network error"
          );
        }

        const responseData =
          await response.json();

        // FIX: also verify we're still on the same
        // category when the response arrives — not just
        // that the effect wasn't cleaned up.
        if (
          !isActive ||
          lastCatIdRef.current !==
            currentCategory.catId
        ) {
          return;
        }

        const morenews =
          (
            responseData.morenews || []
          ).slice(0, MAX_ITEMS);

        setCategoryNewsData(
          morenews
        );

        setNoData(
          morenews.length === 0
        );

        setHasMore(
          morenews.length < MAX_ITEMS
        );

        startRef.current =
          morenews.length;

        setMoreError(null);

        setLoading(false);

      } catch (err) {

        if (
          isActive &&
          lastCatIdRef.current ===
            currentCategory.catId
        ) {

          setMoreError(
            err.message
          );

          setLoading(false);
        }
      }
    };

    fetchFirstPage();

    return () => {

      isActive = false;

    };

  }, [
    type,
    categoryPageData,
    ssrMatches
  ]);


  // ====================================================
  // FETCH MORE
  // ====================================================

  useEffect(() => {

    if (
      !inView ||
      !hasMore ||
      isFetchingRef.current ||
      loading
    ) {
      return;
    }

    const currentCategory =
      resolveCategory(type);

    if (
      !currentCategory ||
      lastCatIdRef.current !==
        currentCategory.catId
    ) {
      return;
    }

    // Already reached maximum
    if (
      categoryNewsData.length >= MAX_ITEMS
    ) {
      setHasMore(false);
      return;
    }

    let isActive = true;

    const fetchMore = async () => {

      isFetchingRef.current = true;

      try {

        const total =
          window.innerWidth < 1100
            ? 10
            : 14;

        const remaining =
          MAX_ITEMS -
          categoryNewsData.length;

        const requestTotal =
          Math.min(
            total,
            remaining
          );

        if (requestTotal <= 0) {
          setHasMore(false);
          return;
        }

        const response =
          await fetch(
            `https://www.teluguone.com/news_api/catNewsPaginate?catId=${currentCategory.catId}&start=${startRef.current}&total=${requestTotal}`
          );

        if (!response.ok) {
          throw new Error(
            "Network error"
          );
        }

        const responseData =
          await response.json();

        if (
          !isActive ||
          lastCatIdRef.current !==
            currentCategory.catId
        ) {
          return;
        }

        const moreNews =
          responseData.morenews || [];

        if (
          moreNews.length === 0
        ) {

          setHasMore(false);

        } else {

          setCategoryNewsData(
            (prev) => {

              const combined = [
                ...prev,
                ...moreNews
              ];

              const limited =
                combined.slice(
                  0,
                  MAX_ITEMS
                );

              return limited;
            }
          );

          startRef.current +=
            moreNews.length;

          // Stop at exactly 100
          if (
            categoryNewsData.length +
              moreNews.length >=
            MAX_ITEMS
          ) {
            setHasMore(false);
          }
        }

      } catch (err) {

        if (isActive) {

          setMoreError(
            err.message
          );

        }

      } finally {

        isFetchingRef.current =
          false;
      }

    };

    fetchMore();

    return () => {
      isActive = false;
    };

  }, [
    inView,
    hasMore,
    type,
    loading,
    categoryNewsData.length
  ]);


  // ====================================================
  // PAGE TITLE
  // ====================================================

  const pageTitle =
    pageTitleProp ||
    resolveCategory(type)?.pageTitle ||
    "Category Page";


  // ====================================================
  // RENDER
  // ====================================================

  return (

    <div
      className="category-main-news-loader shadow-lg"
    >

      <Helmet>

        <title>
          {pageTitle}
        </title>

      </Helmet>

      {loading ? (

        <div
          className="col-12 cat-loader-div"
          style={{
            width: "100%"
          }}
        >

          <SkeletonGrid
            mobile={mobile}
          />

        </div>

      ) : moreError ? (

        <div
          className="json-loading-error-div"
        >

          <img
            src={
              `${import.meta.env.BASE_URL}assets/images/json_error.png`
            }
            alt="json_loading_error"
          />

        </div>

      ) : noData ? (

        <div
          className="category-no-data-div"
          style={{
            width: "100%",
            textAlign: "center",
            padding: "40px 0"
          }}
        >

          <p>
            No Data Found
          </p>

        </div>

      ) : (

        <>

          {categoryNewsData
            .slice(0, MAX_ITEMS)
            .map(
              (item, index) => (

                <CategoryCardItem
                  key={
                    `${item?.url_link || item?.id || index}-${index}`
                  }
                  index={index}
                  item={item}
                  pn={mobile}
                />

              )
            )}

          {hasMore &&
            !loading &&
            categoryNewsData.length <
              MAX_ITEMS && (

            <div
              className="col-12 cat-loader-div"
              ref={loaderRef}
              style={{
                width: "100%"
              }}
            >

              <HasMoreSkeletonGrid
                mobile={mobile}
              />

            </div>

          )}

        </>

      )}

    </div>
  );

};


export default NewsLeftSideSection;


// ======================================================
// INITIAL SKELETON
// ======================================================

const SkeletonGrid = ({ mobile }) => (

  <>

    {Array(mobile ? 4 : 4)
      .fill(0)
      .map((_, i) => (

        <div
          key={i}
          className="category-dummy-news-card card container-fluid"
        >

          <div className="row g-0">

            <div className="col-12">

              <Skeleton
                type="news-card-square"
              />

            </div>

            <div className="col-12">

              <Skeleton
                type="title"
              />

              {Array(8)
                .fill(0)
                .map((_, j) => (

                  <Skeleton
                    key={j}
                    type="paragraph"
                  />

                ))}

            </div>

          </div>

        </div>

      ))}

  </>

);


// ======================================================
// MORE SKELETON
// ======================================================

const HasMoreSkeletonGrid = ({ mobile }) => (

  <>

    {Array(mobile ? 6 : 8)
      .fill(0)
      .map((_, i) => (

        <div
          key={i}
          className="category-dummy-news-card card container-fluid"
        >

          <div className="row g-0">

            <div className="col-sm-4 col-4">

              <Skeleton
                type="news-card-square"
              />

            </div>

            <div className="col-8 col-md-8">

              <Skeleton
                type="title"
              />

              {Array(8)
                .fill(0)
                .map((_, j) => (

                  <Skeleton
                    key={j}
                    type="paragraph"
                  />

                ))}

            </div>

          </div>

        </div>

      ))}

  </>

);


// ======================================================
// DATE FORMAT
// ======================================================

const formatPubDate = (dateString) => {

  if (!dateString) {
    return "";
  }

  const match =
    dateString.match(
      /^([A-Za-z]{3}) (\d{1,2}), (\d{4}) (\d{1,2}):(\d{2})(AM|PM)$/i
    );

  if (!match) {
    return dateString;
  }

  const [
    ,
    month,
    day,
    year,
    hour,
    minute,
    ampm
  ] = match;

  const monthMap = {

    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11

  };

  const date =
    new Date(
      Number(year),
      monthMap[month],
      Number(day),
      Number(hour) % 12 +
        (
          ampm.toUpperCase() === "PM"
            ? 12
            : 0
        ),
      Number(minute)
    );

  const weekday =
    date.toLocaleDateString(
      "en-US",
      {
        weekday: "short"
      }
    );

  return `${weekday} ${month} ${day}, ${year} ${hour}:${minute}${ampm.toUpperCase()}`;

};


// ======================================================
// NEWS CARD
// ======================================================

const CategoryCardItem = ({
  item,
  index,
  pn
}) => {

  const urlLink =
    item?.url_link;

  const contentPath =
    urlLink?.includes("content/")
      ? urlLink.substring(
          urlLink.indexOf("content/") + 8
        )
      : null;

  const newsUrl =
    contentPath
      ? `/content/${contentPath}`
      : "/";

  return (

    <div
      className="category-news-card card news-card-grid-item"
      style={{
        maxWidth: "100%"
      }}
    >

      <Link
        to={newsUrl}
        style={{
          textDecoration: "none"
        }}
      >

        <div className="row g-0">

          <div className="col-12">

            <img
              loading={
                index === 0 && pn === true
                  ? "eager"
                  : "lazy"
              }
              src={
                item?.stimg
                  ? item.stimg
                  : `${import.meta.env.BASE_URL}assets/images/error_img.webp`
              }
              alt="political-news-img"
              className="category-news-card-img"
            />

          </div>

          <div className="col-12">

            <div
              className="category-news-card-body card-body"
            >

              <h3
                className="category-news-card-title"
              >

                {item?.title
                  ? he.decode(item.title)
                  : "No Title"}

              </h3>

              <p
                className="category-news-card-description"
                dangerouslySetInnerHTML={{
                  __html:
                    item?.smalldesc
                      ? he.decode(
                          item.smalldesc
                        )
                      : ""
                }}
              />

              <p className="card-text">

                <small
                  className="text-body-secondary category-news-card-time notranslate"
                  translate="no"
                >

                  Published on:{" "}
                  {formatPubDate(
                    item?.pubdate
                  )}

                </small>

              </p>

            </div>

          </div>

        </div>

      </Link>

    </div>

  );

};
